// @flow
import React, { type Node } from 'react';
import { Track } from 'angieslist-app-platform';
import { Panel, Label, OverlayTrigger, Tooltip, Button, Row, Col } from 'angieslist-react-components';
import quickBooksLogo from '../../../static/quick-books-logo.png';
import './QuickBooksCard.scss';

// Media breakpoint less than MD (tablets and mobile phones)
const isMobileDevice = () => window.innerWidth < 993;

const tooltip = (
  <Tooltip id="quick-books-card--sync-button-tooltip">
    <p>In order to sync, you need to be an account Admin.</p>
  </Tooltip>
);

type Props = {
  serviceProviderId: number,
  accountingSyncUrl: string,
  isAdmin: Boolean
};

const QuickBooksCard = ({
  serviceProviderId,
  accountingSyncUrl,
  isAdmin,
}: Props): Node => (
  <Panel id="Quick-Books-Card--Container">
    <Row>
      <Col xs={12} md={8} lg={9}>
        <div>
          <img
            alt="Quick Books Logo"
            src={quickBooksLogo}
            className="quick-books-logo"
          />
          <Label className="new-label">New</Label>
        </div>
        <p>
          <small>
            Sync your customers, quotes, invoices, payments,
            and price list with QuickBooks Online.
          </small>
        </p>
      </Col>
      <Col xs={12} md={4} lg={3}>
        <Choose>
          <When condition={isAdmin}>
            <Track>
              <Button
                id="quick-books-card--sync-button-enabled"
                bsSize="xsmall"
                href={`${accountingSyncUrl}&serviceProviderId=${serviceProviderId}`}
                target="_blank"
                rel="noreferrer"
                bsStyle="default-office"
              >
                Sync
              </Button>
            </Track>
          </When>
          <Otherwise>
            <OverlayTrigger placement={isMobileDevice() ? 'bottom' : 'left'} overlay={tooltip}>
              <Button
                id="quick-books-card--sync-button-disabled"
                bsSize="xsmall"
              >
                Sync
              </Button>
            </OverlayTrigger>
          </Otherwise>
        </Choose>
      </Col>
    </Row>
  </Panel>
);

export default(QuickBooksCard);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/QuickBooksCard.js